import React from "react";

interface HorizontalGalleryProps {
  children: JSX.Element | JSX.Element[] | null;
}

const HorizontalGallery = (props: HorizontalGalleryProps) => {
  const { children } = props;
  return <div style={styles.overflow}>{children}</div>;
};

const styles = {
  overflow: {
    overflow: "auto",
    whiteSpace: "nowrap",
  },
};

export default HorizontalGallery;
